/****************************************
 * Auto Generated by FePermissionGenerator *
 * Don't edit it manually                  *
 ****************************************/

export default {
  LEAD_EDIT: 1,
  LEAD_ASSIGN: 2,
  LEAD_CLEAN: 3,
  LEAD_CONVERT: 4,
  POTENTIAL_EDIT: 5,
  POTENTIAL_ASSIGN: 6,
  POTENTIAL_RELEASE: 7,
  POTENTIAL_OBTAIN: 8,
  POTENTIAL_TURN_TO_ORDER: 9,
  POTENTIAL_OBTAIN_ASSIGN: 30,
  ORDER_EDIT: 10,
  ORDER_INFO_EDIT: 11,
  ORDER_PAYMENT_REVIEW: 12,
  ORDER_SUBMIT_ONLINE_REVIEW: 13,
  ORDER_ONLINE_REVIEW: 14,
  ORDER_REJECT: 32,
  ADD_UPDATE_HOUSE_RELATIONSHIP: 38,
  OUTSIDE_EDIT: 15,
  OUTSIDE_IS_REVIEW: 16,
  OUTSIDE_OS_REVIEW: 17,
  OUTSIDE_ACCEPT: 18,
  OUTSIDE_BACK_FILL: 19,
  OUTSIDE_WITHDRAW: 20,
  OUTSIDE_CLOSE: 21,
  OUTSIDE_CREATE: 22,
  REGISTRATION_CREATE: 23,
  REGISTRATION_EDIT: 24,
  REGISTRATION_WITHDRAW: 25,
  REGISTRATION_CLOSE: 26,
  REGISTRATION_DETAIL: 27,
  LEAD_RELEASE: 28,
  LEAD_OBTAIN: 29,
  LEAD_OBTAIN_ASSIGN: 31,
  NEIGHBOURHOOD_BASE_VIEW_SELF: 33,
  NEIGHBOURHOOD_MANAGE: 34,
  NEIGHBOURHOOD_BASE_VIEW_GROUP: 37,
  REGISTRATION_SUBMIT: 35,
  REGISTRATION_EDIT_SELF_OPEN: 36,
  LEAD_UPDATE_ACCOUNT: 40,
  OPS_REGISTRATION_ASSIGN_REVIEW: 1000,
  OPS_REGISTRATION_REGISTER_REVIEW_REJECT: 1001,
  OPS_REGISTRATION_ADVERTISING_INFO_EDIT: 1002,
  OPS_REGISTRATION_GDT_REGISTER: 1003,
  OPS_REGISTRATION_MP_REGISTER: 1004,
  OPS_REGISTRATION_GDT_EDIT: 1005,
  OPS_REGISTRATION_MP_WITHDRAW: 1006,
  OPS_REGISTRATION_ACCOUNT_INFO_VIEW: 1007,
  OPS_REGISTRATION_UPDATE_REGISTRAR: 1008,
  LEAD_DISTRIBUTE_COMMIT_TO_POOL: 1009,
  POTENTIAL_ORDER_ENTRY: 81925,
};
